export type MessageType = {
  time: Date;
  text: string;
  sender: "lisa" | "user";
  glosas?: string[];
};

export type Conversation = {
  id: string;
  title: string;
  messages: MessageType[];
  createdAt: Date;
};

const HISTORY_KEY = "lisa_chat_history";

export function loadHistory(): Conversation[] {
  try {
    const stored = localStorage.getItem(HISTORY_KEY);
    if (stored) {
      const parsed = JSON.parse(stored) as Conversation[];
      return parsed.map((c) => ({
        ...c,
        createdAt: new Date(c.createdAt),
        messages: c.messages.map((m) => ({ ...m, time: new Date(m.time) })),
      }));
    }
  } catch {}
  return [];
}

export function saveConversation(conversation: Conversation): void {
  const history = loadHistory();
  const index = history.findIndex((c) => c.id === conversation.id);
  if (index >= 0) {
    history[index] = conversation;
  } else {
    history.unshift(conversation); // mais recente primeiro
  }
  localStorage.setItem(HISTORY_KEY, JSON.stringify(history));
}

export function deleteConversation(id: string): void {
  const history = loadHistory().filter((c) => c.id !== id);
  localStorage.setItem(HISTORY_KEY, JSON.stringify(history));
}

export function generateId(): string {
  return Date.now().toString(36) + Math.random().toString(36).slice(2);
}

export function generateTitle(messages: MessageType[]): string {
  const firstUser = messages.find((m) => m.sender === "user");
  if (!firstUser) return "Nova conversa";
  return firstUser.text.length > 40
    ? firstUser.text.slice(0, 40) + "..."
    : firstUser.text;
}